<template>
  <div class="container page-py mobile-container">
    <h2>{{ $t('helpCenter_contentCreation') }}</h2>
    <div
      class="container-for-main-info"
      style="scroll-behavior: smooth"
    >
      <div class="main-info">
        <div id="renders" ref="renders" class="paragraph-block">
          <h3 id="renderers">
            {{ $t('renders') }}
          </h3>
          <div id="settings-photo-mode" ref="settings-photo-mode">
            <h4>
              {{ $t('photoModeSettings') }}
            </h4>
            <div class="paragraph-steps">
              <p class="paragraph-steps-text">
                {{ $t('photoModeSettingsInstr') }}
              </p>
            </div>
            <div class="paragraph-steps">
              <h5>
                {{ $t('photoModeSettingsOne') }}
              </h5>
              <div class="step-block step-block_mini-margin">
                <p class="step-element">
                  {{ $t('photoModeSettingsSave') }}
                </p>
                <p class="step-element">
                  {{ $t('photoModeSettingsResolution') }}
                </p>
                <p class="step-element">
                  {{ $t('photoModeSettingsFormat') }}
                </p>
              </div>
              <h5>
                {{ $t('helpCenter_addingPoints') }}
              </h5>
              <div class="paragraph-steps">
                <p class="paragraph-steps-text">
                  {{ $t('helpCenter_functionAddingShootPoints') }}
                </p>
                <p class="paragraph-steps-text">
                  {{ $t('helpCenter_severalImages_sameProject') }}
                </p>
              </div>
              <h5>
                {{ $t('helpCenter_cameraSettings') }}
              </h5>
              <p class="paragraph-text">
                {{ $t('helpCenter_advancedCameraSettings') }}
              </p>
              <div class="step-block step-block_mini-margin">
                <p class="step-element">
                  {{ $t('helpCenter_cameraPositionRotation') }}
                </p>
                <p class="step-element">
                  {{ $t('helpCenter_theLens') }}
                </p>
                <p class="step-element">
                  {{ $t('helpCenter_theStage') }}
                </p>
                <p class="step-element">
                  {{ $t('helpCenter_lighting') }}
                </p>
                <p class="step-element">
                  {{ $t('helpCenter_filters') }}
                </p>
              </div>
            </div>
            <h4 id="how-to-make-render" ref="how-to-make-render">
              {{ $t('howToMakeRender') }}
            </h4>
            <div class="paragraph-steps">
              <p class="paragraph-steps-text">
                {{ $t('howToMakeRenderInstr') }}
              </p>
              <p class="paragraph-steps-text">
                {{ $t('howToMakeRenderInstr2') }}
              </p>
              <img v-if="locale === 'ru'"
                :src="`${staticUrl}/images/help-center/Content-Renders-02-RU.webp`"
                :alt="$t('howToMakeRender')"
                class="article-image"
              />
              <img v-else
                :src="`${staticUrl}/images/help-center/Content-Renders-02-EN.webp`"
                :alt="$t('howToMakeRender')"
                class="article-image"
              />
              <div class="i-block">
                <div class="i-block-info">
                  <div class="i-block-info-icon">
                    <div class="info-icon-background">
                      <div class="info-icon-text">
                        {{ $t('i') }}
                      </div>
                    </div>
                  </div>
                  <div class="i-block-info-text">
                    {{ $t('resetFilters') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="fly-tour" ref="fly-tour" class="paragraph-block">
          <h3 id="videoFlyThroughs">
            {{ $t('videoFlyThroughs') }}
          </h3>
          <h4>
            {{ $t('videoModeSettings') }}
          </h4>
          <div class="paragraph-steps">
            <p>{{ $t('videoFlyThroughsT1') }}</p>
            <p>
              {{ $t('videoModeSettingsInstr') }}
            </p>
          </div>
          <div class="paragraph-steps">
            <h5>
              {{ $t('videoModeSettingsOne') }}
            </h5>
            <div class="step-block step-block_mini-margin">
              <p class="step-element">
                {{ $t('videoModeSettingsFolder') }}
              </p>
              <p class="step-element">
                {{ $t('videoModeSettingsResolution') }}
              </p>
              <p class="step-element">
                {{ $t('videoModeSettingsFrameRate') }}
              </p>
            </div>
            <h5>
              {{ $t('cameraView') }}
            </h5>
            <div class="step-block step-block_mini-margin">
              <p class="step-element">
                {{ $t('sensorWidth') }}
              </p>
              <p class="step-element">
                {{ $t('sensorHeight') }}
              </p>
              <p class="step-element">
                {{ $t('focusDistance') }}
              </p>
            </div>
            <h5>
              {{ $t('diaphragm') }}
            </h5>
            <div class="step-block step-block_mini-margin">
              <p class="step-element">
                {{ $t('aperture') }}
              </p>
            </div>
            <h5>
              {{ $t('focusOption') }}
            </h5>
            <div class="step-block step-block_mini-margin">
              <p class="step-element">
                {{ $t('focusOptionNo') }}
              </p>
              <p class="step-element">
                {{ $t('focusOptionManual') }}
              </p>
              <p class="step-element">
                {{ $t('focusOptionObject') }}
              </p>
            </div>
            <div class="i-block">
              <div class="i-block-info">
                <div class="i-block-info-icon">
                  <div class="info-icon-background">
                    <div class="info-icon-text">
                      {{ $t('i') }}
                    </div>
                  </div>
                </div>
                <div class="i-block-info-text">
                  {{ $t('resetFilters') }}
                </div>
              </div>
            </div>
          </div>
          <h4
            id="how-to-make-video-fly-throughs"
            ref="how-to-make-video-fly-throughs"
          >
            {{ $t('howToMakeVideoFly') }}
          </h4>
          <div class="paragraph-steps">
            <p class="paragraph-steps-text">
              {{ $t('howToMakeVideoFlyInstr') }}
            </p>
            <p class="paragraph-steps-text">
              {{ $t('howToMakeVideoFlySave') }}
            </p>
            <div class="i-block">
              <div class="i-block-info">
                <div class="i-block-info-icon">
                  <div class="info-icon-background">
                    <div class="info-icon-text">
                      {{ $t('important') }}
                    </div>
                  </div>
                </div>
                <div class="i-block-info-text">
                  {{ $t('rButton') }}
                </div>
              </div>
            </div>
            <img v-if="locale === 'ru'"
              :src="`${staticUrl}/images/help-center/Content-Renders-03-RU.webp`"
              :alt="$t('howToMakeVideoFly')"
              class="article-image"
            />
            <img v-else
              :src="`${staticUrl}/images/help-center/Content-Renders-03-EN.webp`"
              :alt="$t('howToMakeVideoFly')"
              class="article-image"
            />
          </div>
        </div>
        <div id="3d-tour-for-web" ref="3d-tour-for-web">
          <h3 id="tours3DWeb">
            {{ $t('tourForWebsite') }}
          </h3>
          <p class="paragraph-text">
            {{ $t('howToMakeTour') }}
          </p>
          <div class="i-block">
            <div class="i-block-info">
              <div class="i-block-info-icon">
                <div class="info-icon-background">
                  <div class="info-icon-text">
                    {{ $t('important') }}
                  </div>
                </div>
              </div>
              <div class="i-block-info-text">
                {{ $t('resetFilters') }}
              </div>
            </div>
          </div>
          <video
            v-if="locale === 'ru'"
            class="video-loop"
            no-controls
            autoplay
            loop
            playsinline
            muted
          >
            <source
              :src="`${staticUrl}/video/SC_demonstration_03.mp4`"
              type="video/mp4"
            />
          </video>
          <video
            v-else
            class="video-loop"
            no-controls
            autoplay
            loop
            playsinline
            muted
          >
            <source
              :src="`${staticUrl}/video/SC_demonstration_04_en.mp4`"
              type="video/mp4"
            />
          </video>
          <p class="still-questions">
            <a
              href="https://dreamflat.design/tours/Tour_from_14.04.2023_18-08-22-498/index.htm?n=1"
              class="link"
              target="_blank"
              >{{ $t('followLink') }}</a
            >
            {{ $t('watch3dTour') }}
          </p>
        </div>
        <div id="interactive-tour" ref="interactive-tour">
          <h3 id="interactiveTours">
            {{ $t('interactiveTour') }}
          </h3>
          <p class="paragraph-text">
            {{ $t('dreamFlatInteractiveTour') }}
          </p>
          <p class="paragraph-text">
            {{ $t('dreamFlatInteractiveTourHideInterface') }}
          </p>
          <video
            v-if="locale === 'ru'"
            class="video-loop"
            no-controls
            autoplay
            loop
            playsinline
            muted
          >
            <source
              :src="`${staticUrl}/video/SC_demonstration_04.mp4`"
              type="video/mp4"
            />
          </video>
          <video
            v-else
            class="video-loop"
            no-controls
            autoplay
            loop
            playsinline
            muted
          >
            <source
              :src="`${staticUrl}/video/SC_demonstration_05_en.mp4`"
              type="video/mp4"
            />
          </video>
        </div>
        <div id="vr-mode" ref="vr-mode">
          <h3 id="vr">
            {{ $t('vr') }}
          </h3>
          <p class="paragraph-text">
            {{ $t('dreamFlatVrMode') }}
          </p>
          <div class="video-frame">
            <iframe
              width="100%"
              height="419"
              src="https://www.youtube.com/embed/xHQ49qlEbQY"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            />
          </div>
        </div>
        <div id="helpСenter_createСontent_render_equipment" ref="render-tools">
          <h3 id="tools">
            {{ $t('helpСenter_createСontent_render_equipment') }}
          </h3>
          <p class="paragraph-text">
            {{ $t('helpCenter_advancedSettings_modeRender') }}
          </p>
          <p class="paragraph-text">
            {{ $t('helpCenter_renderingMode') }}
          </p>
          <p class="paragraph-text">
            {{ $t('helpCenter_renderPreview') }}
          </p>
          <p class="paragraph-text">
            {{ $t('helpCenter_shootingSettings') }}
          </p>
          <img v-if="locale === 'ru'"
            :src="`${staticUrl}/images/help-center/Content-Renders-04-RU.webp`"
            :alt="$t('helpCenter_createContent_render_equipment')"
            class="article-image"
          />
          <img v-else
            :src="`${staticUrl}/images/help-center/Content-Renders-04-EN.webp`"
            :alt="$t('helpCenter_createContent_render_equipment')"
            class="article-image"
          />
          <p class="paragraph-text">
            {{ $t('helpCenter_currentMethod_doesNotChangeSettings') }}
          </p>
          <p class="paragraph-text">
            {{ $t('helpCenter_pathTracing_simulateLight') }}
          </p>
          <p class="paragraph-text">
            {{ $t('helpCenter_rtxdiRender') }}
          </p>

          <h5 id="current-render-method">
            {{ $t('helpCenter_currentRenderMethod') }}
          </h5>
          <p class="paragraph-text">
            {{ $t('helpCenter_methodDisplayImage') }}
          </p>
          <h5 id="path-tracing">
            {{ $t('helpCenter_pathTracing') }}
          </h5>
          <p class="paragraph-text">
            {{ $t('helpCenter_mostRealisticSimulation') }}
          </p>
          <p class="paragraph-text">
            {{ $t('helpCenter_usingMethod_significantResourcesConsumption') }}
          </p>
          <p class="paragraph-text">
            {{ $t('helpCenter_recommendations') }}
          </p>
          <ul>
            <li>{{ $t('helpCenter_tracerSettingsRecommendations') }}</li>
            <li>{{ $t('helpCenter_increaseDetailQuality') }}</li>
            <li>{{ $t('helpCenter_heaviestRenderMode') }}</li>
            <li>{{ $t('helpCenter_highValues_notInfluenceResult') }}</li>
          </ul>
          <h5>
            {{ $t('helpCenter_rtxdi') }}
          </h5>
          <p class="paragraph-text">
            {{ $t('helpCenter_rtxdiMightActive_inGraphicsSettings') }}
          </p>
          <p class="paragraph-text">
            {{ $t('helpCenter_rtxdiMayCreate_negativeEffects') }}
          </p>
          <p class="paragraph-text">
            {{ $t('helpCenter_recommendations_forShootingRtxdi') }}
          </p>
          <p class="paragraph-text">
            {{ $t('helpCenter_rtxdi_simplifiedPathTracing') }}
          </p>
          <h5>
            {{ $t('helpCenter_numberOfFrames') }}
          </h5>
          <p class="paragraph-text">
            {{ $t('helpCenter_paramSeveralFrames_skippedBeforeShooting') }}
          </p>
          <p class="paragraph-text">
            {{ $t('helpCenter_rayTracingParam') }}
          </p>
          <p class="paragraph-text">
            {{ $t('helpCenter_shootingTime_mayIncrese') }}
          </p>
          <h5>
            {{ $t('helpCenter_detailQuality') }}
          </h5>
          <p class="paragraph-text">
            {{ $t('helpCenter_paramDetailQuality') }}
          </p>
          <p class="paragraph-text">
            {{ $t('helpCenter_increaseResolution') }}
          </p>
          <h5>
            {{ $t('helpCenter_numberOfSamples') }}
          </h5>
          <p class="paragraph-text">
            {{ $t('helpCenter_paramLightDistribution') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import {ref} from 'vue';
import {useI18n} from 'vue-i18n';
import {useHead, useRuntimeConfig} from '#imports';

export default {
  setup() {
    const {t, locale} = useI18n();
    const isShowFeedBackModal = ref(false);
    const runtimeConfig = useRuntimeConfig();
    const staticUrl = runtimeConfig.public.vueAppStaticUrl;

    useHead({
      title: `${t('DreamFlat')} - ${t('demonstrateDesign')}`,
      meta: [
        {
          name: 'description',
          content: `${t('demonstrateDesignMetaDesc')}`,
        },
      ],
    });
    useSeoMeta({
      ogTitle: `${t('DreamFlat')} - ${t('demonstrateDesign')}`,
      description: `${t('demonstrateDesignMetaDesc')}`,
      ogDescription: `${t('demonstrateDesignMetaDesc')}`,
      ogImage: 'https://dreamflat.design/prev.webp',
    });

    return {
      slide: ref(1),
      locale,
      mobileNavMenu: ref(false),
      isShowFeedBackModal,
      staticUrl,
    };
  },
};
</script>
<style lang="scss" scoped>
@import 'css/help-center/help-center-general-ctyle';
</style>
